// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ke-0";